<app-three-column-template
  [hasCustomMain]="true"
  [pageData]="pageData()">
  <app-side-navigation
    [addTags]="true"
    [pageData]="pageData()" slot="left-section"></app-side-navigation>
  <app-breadcrumbs [pageData]="pageData()" slot="breadcrumb-section"></app-breadcrumbs>

  @if (pageData().showContents) {
    <app-toc></app-toc>
  }
  <app-ck-viewer [htmlDescription]="pageData()?.summary"></app-ck-viewer>
  <app-ck-viewer
    [fullBody]="true"
    [htmlDescription]="pageData()?.htmlDescription"></app-ck-viewer>

  <app-related-items [pageData]="pageData()"></app-related-items>

  <ng-container slot="right-section">

    <app-links-section
      [isQuickLinks]="true"
      [links]="pageData()?.quickUrls"
      [title]="'Quick links'"></app-links-section>

    <app-default-portlets [pageData]="pageData()"></app-default-portlets>

  </ng-container>
</app-three-column-template>
